<script setup lang="ts">
import { ref, computed, watch, onMounted, emit } from 'vue'; 

const props = defineProps({
  value: {
    type: Number,
    default: 4,
  },
  vorlage: {
    type: Object,
    default: () => ({}),
  },
  maxStars: {
    type: Number,
    default: 4,
  },
});

const emit = defineEmits(['ratingData']);

const isHovered = ref(false);
const hoverValue = ref(0);

const setRating = (newRating) => {
  emit('ratingData', {
      newRating: newRating, 
      vorlage: props.vorlage
  });
};

const hoverRating = (value) => {
  if (isHovered.value) {
    hoverValue.value = value;
  }
};

const resetHover = () => {
  hoverValue.value = 0;
};

</script>

<template>
  <div class="star-rating relative h-5 w-20">

    <div class="absolute inset-0 w-full h-full p-0 flex gap-2 items-center bg-gray-100 star-container">
      <template v-for="i in props.maxStars" :key="i">
        <div
          v-if="i != 1"
          @click="setRating(i)"
          @mouseover="hoverRating(i)"
          @mouseleave="resetHover"
          class="z-10"
          :class="['star', i <= (isHovered ? hoverValue : props.value) ? 'filled' : '']"
        >
          <i class="fa-duotone fa-thin fa-star"></i>
        </div>
      </template>
    </div>
  </div>
</template>
  
<style scoped>
.star-rating {
  display: inline-block;
}

.star {
  display: inline-block;
  cursor: pointer;
  @apply text-primary-300 text-f5;
}

.filled {
  @apply text-primary;
}
</style>
